// document.querySelector('#delivery-items').style.display = 'none';

// console.log('Custom JS');

const tabsAccordion = document.querySelector('.faq_section .faqs-row .tabs-accordion');
console.log(tabsAccordion);

tabsAccordion?.addEventListener('click', function (e) {
    // console.log(e.target);

    const targetElement = e.target;

    targetElement.classList.toggle('active');

    const nextSiblingElement = targetElement.nextElementSibling;
    // console.log(nextSiblingElement);

    nextSiblingElement.classList.toggle('active');
});



const iframe = document.querySelector('iframe');
iframe.contentWindow.postMessage(
  {
    action: 'addCSS',
    css: `
    .message__messaging,
    .message__messaging .message__headline span,
    .message__messaging .message__sub-headline span,
    .message__messaging .message__disclaimer span {
      color: #111111;
      font-size: 15px;
      font-family: Josefin Sans, sans-serif;
      font-style: normal;
      font-weight: 300;
    }
    `
  },
  '*'
);



